module.exports = __webpack_public_path__ + "static/media/BAJAJ-AUTO_F1.2044508e.txt";